export default __webpack_public_path__ + "fk-cp-zion/img/payment-method_69e7ec.svg";